import UserClient from "./userClient";
import axios from "axios";

export default class FuneralClient extends UserClient {
  constructor() {
    super("funeral");

    this.httpClient = axios.create({
      baseURL: `${process.env.VUE_APP_APIURL}/api/app/funeral`,
      headers: { Authorization: `${this.access_token}` }
    });
  }
}
